import type { AxiosResponse } from 'axios';

import { httpClient } from '@/src/shared/services/api.services';
import { API_URLS } from '@/src/shared/services/endpoints/apiUrls';

import type {
    NormDocTokenResponseData,
    SASTokenResponseData,
} from './responseModel/sasTokenResponse';

export const fetchSASToken = async (
    isExpToken = false
): Promise<AxiosResponse<SASTokenResponseData>> => {
    try {
        const response = await httpClient.get(
            isExpToken ? API_URLS.GET_SAS_TOKEN_WITH_EXP : API_URLS.GET_SAS_TOKEN
        );
        return response;
    } catch (error: any) {
        return error?.cause.data;
    }
};

export const fetchNormDocToken = async (): Promise<AxiosResponse<NormDocTokenResponseData>> => {
    try {
        const response = await httpClient.get(API_URLS.GET_NORM_DOC_TOKEN);
        return response;
    } catch (error: any) {
        return error?.cause.data;
    }
};
